import React from 'react';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
// @ts-ignore
import * as XLSX from 'xlsx';

export const ImportTemplateCard = () => {
  const handleDownloadTemplate = () => {
    const ws = XLSX.utils.json_to_sheet([
      { nombre: 'Andrés Ruiz', clase: '6º B', email: 'andres@ejemplo.com', telefono: '600000000' },
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Alumnos');
    XLSX.writeFile(wb, 'plantilla_alumnos.xlsx');
  };

  return (
    <div className="flex-1 bg-muted rounded-lg p-4 border">
      <div className="flex items-center gap-2 mb-2">
        <Download className="w-5 h-5 text-primary" />
        <span className="font-semibold">1. Descarga la Plantilla</span>
      </div>
      <p className="text-sm text-muted-foreground mb-2">Descarga la plantilla Excel con el formato correcto</p>
      <Button onClick={handleDownloadTemplate} variant="outline" className="w-full md:w-auto">
        <Download className="w-4 h-4 mr-2" />
        Descargar Plantilla Excel
      </Button>
    </div>
  );
};